import type { InvestmentTable } from '@/types';

const STORAGE_KEY = 'investment-table-library';

export interface SavedInvestmentTable {
  id: string;
  name: string;
  savedAt: number;
  table: InvestmentTable;
}

export function getSavedTables(): SavedInvestmentTable[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveTableToLibrary(name: string, table: InvestmentTable): SavedInvestmentTable {
  const saved: SavedInvestmentTable = {
    id: `lib-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    name,
    savedAt: Date.now(),
    table: { ...table, id: `lib-${Date.now()}` },
  };
  const existing = getSavedTables();
  existing.push(saved);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
  return saved;
}

export function deleteSavedTable(id: string): void {
  const existing = getSavedTables().filter((t) => t.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
}
